import { createReducer } from '@reduxjs/toolkit';
import { loadQueryResultsStart } from '../queryResults';
import {
  loadItemDetailStart,
  loadItemPerformanceDataFailure,
  loadItemPerformanceDataStart,
  loadItemPerformanceDataSuccess,
  loadItemResponseFailure,
  loadItemResponseSuccess,
  loadItemSampleResponsesFailure,
  loadItemSampleResponsesSuccess,
  loadItemScoreGuideFailure,
  loadItemScoreGuideSuccess
} from './itemDetail.actions';
import { IItemDetailState } from './models';

const INITIAL_STATE: IItemDetailState = {
  item: null,
  itemResponse: null,
  itemScoreGuide: '',
  itemSampleResponses: '',
  itemPerformanceData: null,
  loadingResponse: false,
  loadingScoreGuide: false,
  loadingSampleResponses: false,
  loadingPerformanceData: false,
  loadedResponse: false,
  loadedScoreGuide: false,
  loadedSampleResponses: false,
  loadedPerformanceData: false,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errMsg: null
};

export const ItemDetailReducer = createReducer( INITIAL_STATE, (builder) => {
  builder
    .addCase(loadQueryResultsStart, () : IItemDetailState=> ({
      ...INITIAL_STATE
    }))
    .addCase(loadItemDetailStart, (state, action): IItemDetailState => ({
      ...state,
      item: action.payload.gridItem,
      itemResponse: null,
      itemScoreGuide: '',
      itemSampleResponses: '',
      loadingResponse: true,
      loadingScoreGuide: true,
      loadingSampleResponses: true,
      loadingPerformanceData: true,
      loadedResponse: false,
      loadedScoreGuide: false,
      loadedSampleResponses: false,
      loadedPerformanceData: false
    }))
    .addCase(loadItemResponseSuccess, (state, action): IItemDetailState => ({
      ...state,
      itemResponse: action.payload,
      loadingResponse: false,
      loadedResponse: true,
    }))
    .addCase(loadItemScoreGuideSuccess, (state, action): IItemDetailState => ({
      ...state,
      itemScoreGuide: action.payload,
      loadingScoreGuide: false,
      loadedScoreGuide: true,
    }))
    .addCase(loadItemSampleResponsesSuccess, (state, action): IItemDetailState => ({
      ...state,
      itemSampleResponses: action.payload,
      loadingSampleResponses: false,
      loadedSampleResponses: true,
    }))
    .addCase(loadItemPerformanceDataStart, (state): IItemDetailState => ({
      ...state,
      loadingPerformanceData: true,
      loadedPerformanceData: false,
    }))
    .addCase(loadItemPerformanceDataSuccess, (state, action): IItemDetailState => ({
      ...state,
      itemPerformanceData: Array.isArray(action.payload) ? action.payload : action.payload.result,
      loadingPerformanceData: false,
      loadedPerformanceData: true,
    }))
    .addCase(loadItemResponseFailure, (state, action): IItemDetailState => ({
      ...state,
      itemResponse: null,
      loadingResponse: false,
      loadedResponse: false,
      errMsg: action.payload
    }))
    .addCase(loadItemScoreGuideFailure, (state, action): IItemDetailState => ({
      ...state,
      itemScoreGuide: '',
      loadingScoreGuide: false,
      loadedScoreGuide: false,
      errMsg: action.payload
    }))
    .addCase(loadItemSampleResponsesFailure, (state, action): IItemDetailState => ({
      ...state,
      itemSampleResponses: '',
      loadingSampleResponses: false,
      loadedSampleResponses: false,
      errMsg: action.payload
    }))
    .addCase(loadItemPerformanceDataFailure, (state, action): IItemDetailState => ({
      ...state,
      itemPerformanceData: null,
      loadingPerformanceData: false,
      loadedPerformanceData: false,
      errMsg: action.payload
    }));
});

export default ItemDetailReducer;